import Card from 'react-bootstrap/Card';
import Container from 'react-bootstrap/Container';
import Button from 'react-bootstrap/Button';
import Badge from 'react-bootstrap/Badge';
import Form from 'react-bootstrap/Form';
import Row from 'react-bootstrap/Row';
import Col from 'react-bootstrap/Col';
import InputGroup from 'react-bootstrap/InputGroup';
import React, { useState } from "react";
import axios from 'axios';
import Carousel from 'react-bootstrap/Carousel';
import pic1 from '../images/pic1.png';
import pic2 from '../images/pic2.png';
import pic3 from '../images/pic3.png';
import Swal from "sweetalert2";

function CreateAccount() {
  const [newAccount, setNewAccount] = useState(null);

  const handleCreateAccount = async () => {
      try {
          const response = await axios.post('http://localhost:4000/create-account');
          setNewAccount(response.data);
          Swal.fire("Success", "Akaun Baru Berjaya Diwujudkan", "success");
      } catch(error) {
          Swal.fire("Error!", `Error Add Account`, "error");
      }
  };

  return (
    <>
      <Container>
      <Row><Col>
      <Carousel>
          <Carousel.Item>
            <img src={pic1} alt="Gambar 1" width={'1600px'} height={'300px'} />
            <Carousel.Caption>
              <h3>Decentralization</h3>
            </Carousel.Caption>
          </Carousel.Item>
          <Carousel.Item>
            <img src={pic2} alt="Gambar 2" width={'1600px'} height={'300px'} />
            <Carousel.Caption>
              <h3>Security and Immutability</h3>
            </Carousel.Caption>
          </Carousel.Item>
          <Carousel.Item>
            <img src={pic3} alt="Gambar 3" width={'1600px'} height={'300px'} />
            <Carousel.Caption>
              <h3>Smart Contracts and DApps</h3>
            </Carousel.Caption>
          </Carousel.Item>
        </Carousel>
      </Col></Row>
        <Row><Col>
      {!newAccount && 
        <Card border='primary'>
          <Card.Header style={{ backgroundColor:'blue', color:'white' }}>Wujudkan Akaun Baru.</Card.Header>
          <Card.Body><p style={{textAlign: "center"}}>Tekan Butang Untuk Membuat Akaun Baru.<br />
          <Button variant='primary' onClick={handleCreateAccount}>Cipta Akaun</Button></p></Card.Body>
        </Card>
      }
      {newAccount && (
        <Card border='success'>
          <Card.Header style={{ backgroundColor:'green', color:'white' }}>Akaun Baru Dicipta</Card.Header>
          <Card.Body><p style={{textAlign: "center"}}><Badge bg="info">Tahniah!! Akaun Berjaya Dicipta.</Badge><br />
          <InputGroup className="mb-3">
            <InputGroup.Text id="basic-addon3">
              Address
            </InputGroup.Text>
            <Form.Control id="basic-url" aria-describedby="basic-addon3" value={newAccount.address} readOnly />
          </InputGroup>
          <InputGroup className="mb-3">
            <InputGroup.Text id="basic-addon2">
              Private Key
              </InputGroup.Text>
              <Form.Control id="basic-url" aria-describedby="basic-addon2" value={newAccount.privateKey} readOnly />
              </InputGroup>
          </p></Card.Body>
        </Card>
      )}
      </Col></Row>
      </Container>
    </>
  );
};
  
export default CreateAccount;